(function(){
  function setupNavSlider(){
    var nav = document.querySelector('.header__inline-menu > .list-menu--inline');
    if(!nav) return;
    var container = document.querySelector('.header__inline-menu');

    // Clean any legacy overflow artifacts
    var legacyMore = nav.querySelector('li.nav-more');
    if (legacyMore) legacyMore.remove();
    Array.from(nav.children).forEach(function(li){
      if (li && li.style) li.style.display = '';
      if (li && li.dataset && li.dataset.moved) delete li.dataset.moved;
    });

    var isPointerDown = false;
    var dragStartX = 0;
    var scrollStartLeft = 0;
    var leftBtn = null;
    var rightBtn = null;
    var injectedStyleId = 'nav-slider-style';
    var originalContainerPaddingLeft = '';
    var originalContainerPaddingRight = '';

    function ensureInjectedStyles(){
      if (document.getElementById(injectedStyleId)) return;
      var style = document.createElement('style');
      style.id = injectedStyleId;
      style.type = 'text/css';
      style.textContent = ''+
        '.nav-slider-enabled{scrollbar-width:none; -ms-overflow-style:none;}'+
        '.nav-slider-enabled::-webkit-scrollbar{display:none;}'+
        '.nav-slider__arrow{z-index:5;}'+
        /* Expand dropdown/mega panels to screen edge while slider adds container padding */
        '.header__inline-menu .nav-slider-enabled .mega-menu__content{left:calc(-1 * var(--nav-slider-edge-inset, 28px));right:calc(-1 * var(--nav-slider-edge-inset, 28px));}'+
        '.header__inline-menu .nav-slider-enabled .header__submenu{left:calc(-1 * var(--nav-slider-edge-inset, 28px));right:calc(-1 * var(--nav-slider-edge-inset, 28px));}';
      document.head.appendChild(style);
    }

    function enableSliderStyles(){
      ensureInjectedStyles();
      nav.style.whiteSpace = 'nowrap';
      nav.style.flexWrap = 'nowrap';
      nav.style.overflowX = 'auto';
      nav.style.overflowY = 'hidden';
      nav.style.scrollBehavior = 'smooth';
      nav.style.webkitOverflowScrolling = 'touch';
      nav.style.scrollSnapType = 'x proximity';
      Array.from(nav.children).forEach(function(li){
        if (li && li.style) li.style.scrollSnapAlign = 'start';
      });
      nav.classList.add('nav-slider-enabled');

      if (container) {
        if (getComputedStyle(container).position === 'static') container.style.position = 'relative';
        // Add padding so arrows don't overlap nav items
        if (!originalContainerPaddingLeft) originalContainerPaddingLeft = container.style.paddingLeft;
        if (!originalContainerPaddingRight) originalContainerPaddingRight = container.style.paddingRight;
        container.style.paddingLeft = '28px';
        container.style.paddingRight = '28px';
        // Provide CSS var for edge compensation
        container.style.setProperty('--nav-slider-edge-inset', '28px');
      }
      ensureArrows();
      updateArrowsVisibility();
    }

    function disableSliderStyles(){
      nav.style.whiteSpace = '';
      nav.style.flexWrap = 'nowrap';
      nav.style.overflowX = '';
      nav.style.overflowY = '';
      nav.style.scrollBehavior = '';
      nav.style.webkitOverflowScrolling = '';
      nav.style.scrollSnapType = '';
      Array.from(nav.children).forEach(function(li){
        if (li && li.style) li.style.scrollSnapAlign = '';
      });
      nav.classList.remove('nav-slider-enabled');
      removeArrows();
      if (container) {
        container.style.position = '';
        // Restore original padding
        container.style.paddingLeft = originalContainerPaddingLeft;
        container.style.paddingRight = originalContainerPaddingRight;
        container.style.removeProperty('--nav-slider-edge-inset');
      }
    }

    function applyMode(){
      // Mobile (<750): theme handles drawer; keep as-is
      if (window.innerWidth < 750) {
        disableSliderStyles();
        return;
      }
      // Wide desktop (>=1440): everything fits; no slider
      if (window.innerWidth >= 1440) {
        disableSliderStyles();
        return;
      }
      // Between: enable horizontal slider
      enableSliderStyles();
    }

    function createArrow(direction){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nav-slider__arrow nav-slider__arrow--' + direction;
      btn.setAttribute('aria-label', direction === 'left' ? 'Scroll menu left' : 'Scroll menu right');
      btn.style.position = 'absolute';
      btn.style.top = '50%';
      btn.style.transform = 'translateY(-50%)';
      btn.style[direction === 'left' ? 'left' : 'right'] = '0';
      btn.style.display = 'flex';
      btn.style.alignItems = 'center';
      btn.style.justifyContent = 'center';
      btn.style.width = '20px';
      btn.style.height = '24px';
      btn.style.border = 'none';
      btn.style.background = 'transparent';
      btn.style.cursor = 'pointer';
      btn.style.transition = 'opacity 150ms ease';
      btn.style.opacity = '0';

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 10 6');
      svg.setAttribute('aria-hidden', 'true');
      svg.style.width = '14px';
      svg.style.height = '14px';
      svg.style.transform = direction === 'left' ? 'rotate(90deg)' : 'rotate(-90deg)';
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill', 'currentColor');
      // Use the same caret path as dropdowns (icon-caret)
      path.setAttribute('d', 'M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z');
      svg.appendChild(path);
      btn.appendChild(svg);

      btn.addEventListener('click', function(){
        var amount = Math.max(160, Math.floor(nav.clientWidth * 0.6));
        var delta = direction === 'left' ? -amount : amount;
        nav.scrollBy({ left: delta, behavior: 'smooth' });
      });
      return btn;
    }

    function ensureArrows(){
      if (!container) return;
      if (!leftBtn) {
        leftBtn = createArrow('left');
        container.appendChild(leftBtn);
      }
      if (!rightBtn) {
        rightBtn = createArrow('right');
        container.appendChild(rightBtn);
      }
    }

    function removeArrows(){
      if (leftBtn && leftBtn.parentNode) leftBtn.parentNode.removeChild(leftBtn);
      if (rightBtn && rightBtn.parentNode) rightBtn.parentNode.removeChild(rightBtn);
      leftBtn = null;
      rightBtn = null;
    }

    function updateArrowsVisibility(){
      if (!leftBtn || !rightBtn) return;
      var canScroll = nav.scrollWidth > nav.clientWidth + 2;
      if (!canScroll) {
        leftBtn.style.display = 'none';
        rightBtn.style.display = 'none';
        return;
      }
      var atStart = nav.scrollLeft <= 1;
      var atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1;
      leftBtn.style.display = atStart ? 'none' : 'flex';
      rightBtn.style.display = atEnd ? 'none' : 'flex';
      leftBtn.style.opacity = '1';
      rightBtn.style.opacity = '1';
    }

    // Drag-to-scroll
    function onPointerDown(e){
      isPointerDown = true;
      dragStartX = e.clientX || (e.touches && e.touches[0] && e.touches[0].clientX) || 0;
      scrollStartLeft = nav.scrollLeft;
      nav.classList.add('dragging');
    }
    function onPointerMove(e){
      if (!isPointerDown) return;
      var x = e.clientX || (e.touches && e.touches[0] && e.touches[0].clientX) || 0;
      var delta = dragStartX - x;
      nav.scrollLeft = scrollStartLeft + delta;
    }
    function onPointerUp(){
      isPointerDown = false;
      nav.classList.remove('dragging');
      updateArrowsVisibility();
    }

    nav.addEventListener('mousedown', onPointerDown);
    nav.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);
    nav.addEventListener('touchstart', onPointerDown, { passive: true });
    nav.addEventListener('touchmove', onPointerMove, { passive: true });
    nav.addEventListener('touchend', onPointerUp);
    nav.addEventListener('scroll', function(){
      if (nav.classList.contains('nav-slider-enabled')) updateArrowsVisibility();
    });

    // Convert vertical wheel to horizontal scroll when slider is active
    nav.addEventListener('wheel', function(e){
      if (!nav.classList.contains('nav-slider-enabled')) return;
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        nav.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });

    // Initial and reactive application
    setTimeout(applyMode, 50);
    var debounce;
    window.addEventListener('resize', function(){
      clearTimeout(debounce);
      debounce = setTimeout(applyMode, 100);
    });
    window.addEventListener('load', applyMode);
    if(document.fonts && document.fonts.ready){
      document.fonts.ready.then(applyMode);
    }
    if('ResizeObserver' in window){
      var ro = new ResizeObserver(function(){
        if (nav.classList.contains('nav-slider-enabled')) updateArrowsVisibility();
      });
      ro.observe(nav);
    }

    // Desktop-only hybrid: hover to preview, click to lock open
    function setupHoverClickHybrid(){
      var isDesktop = window.matchMedia('(min-width: 990px)');
      var state = new WeakMap(); // details -> { hoverOpenTimer, hoverCloseTimer, locked }

      function getState(d){
        var s = state.get(d);
        if (!s) { s = { hoverOpenTimer: null, hoverCloseTimer: null, locked: false }; state.set(d, s); }
        return s;
      }

      function closeSiblings(current){
        var all = container ? container.querySelectorAll('header-menu > details') : [];
        all.forEach(function(d){
          if (d === current) return;
          var st = getState(d);
          if (st.locked) return;
          d.removeAttribute('open');
          var sum = d.querySelector('summary');
          if (sum) sum.setAttribute('aria-expanded', 'false');
        });
      }

      function bind(details){
        var summary = details.querySelector('summary');
        if (!summary) return;
        var st = getState(details);

        function openDetails(){
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
          closeSiblings(details);
        }
        function closeDetails(){
          if (st.locked) return;
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }

        // Hover intent
        summary.addEventListener('mouseenter', function(){
          if (!isDesktop.matches) return;
          clearTimeout(st.hoverCloseTimer);
          st.hoverOpenTimer = setTimeout(openDetails, 150);
        });
        details.addEventListener('mouseleave', function(e){
          if (!isDesktop.matches) return;
          clearTimeout(st.hoverOpenTimer);
          st.hoverCloseTimer = setTimeout(closeDetails, 200);
        });

        // Click to lock/unlock
        summary.addEventListener('click', function(e){
          if (!isDesktop.matches) return; // let mobile behavior be native
          e.preventDefault();
          st.locked = !st.locked;
          if (st.locked) {
            openDetails();
          } else {
            closeDetails();
          }
        });

        // Keyboard accessibility
        summary.addEventListener('focusin', function(){ if (!isDesktop.matches) return; openDetails(); });
        details.addEventListener('focusout', function(){ if (!isDesktop.matches) return; setTimeout(function(){ if (!details.contains(document.activeElement)) closeDetails(); }, 0); });
        details.addEventListener('keyup', function(e){ if (e.key === 'Escape') { st.locked = false; closeDetails(); summary.focus(); } });
      }

      var menus = container ? container.querySelectorAll('header-menu > details') : [];
      menus.forEach(bind);

      // Re-evaluate on breakpoint change to clear locks
      if (window.matchMedia) {
        isDesktop.addEventListener('change', function(){
          var all = container ? container.querySelectorAll('header-menu > details') : [];
          all.forEach(function(d){
            var st = getState(d);
            st.locked = false;
            d.removeAttribute('open');
            var sum = d.querySelector('summary');
            if (sum) sum.setAttribute('aria-expanded', 'false');
          });
        });
      }
    }

    setupHoverClickHybrid();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', setupNavSlider);
  } else {
    setupNavSlider();
  }
})();